export default "__VITE_ASSET__r47Q$ipK__"